import React from "react";
import {
  Alert,
  Badge,
  Tag,
  Form,
  Icon,
  Input,
  Button,
  Select,
  Checkbox,
  DatePicker,
  Row,
  Col,
  Radio,
  Slider,
  Tooltip,
  message,
  Switch,
  notification,
} from "antd";
import classnames from "classnames";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import { connect } from "react-redux";
import moment from "moment-timezone";

import {
  updateFollowUpRequest,
  lockFollowUpRequest,
  unlockFollowUpRequest,
} from "../../api/requests";
import {
  getFollowUp90dCreatePermissionBySite,
  getFollowUp90dUpdatePermissionBySite,
  getFollowUp90dLockPermissionBySite,
  getFollowUp90dUnlockPermissionBySite,
  getUserTimezone,
  getUserShortTimezone,
} from "../../reducers/user/selectors";

import classes from "./FollowUp90DayForm.css";
import { logout } from "../../reducers/user/actions";
import { Link } from "react-router-dom";
import FileLink from "../FileLink/FileLink";

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class FollowUp90DayForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      showFollowupForm: true,
      showContactInformation: false,
      showAdditionalContactInformation: false,
      locked: false,
    };
  }

  componentDidMount() {
    this.setState({
      locked: get(this.props, "locked"),
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { followUp90dUpdatePermission } = this.props;

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err && followUp90dUpdatePermission) {
        this.setState({ isLoading: true });

        try {
          const followUp = cloneDeep(values);
          if (followUp.eq_5d_sl_mobility === "null") {
            followUp.eq_5d_sl_mobility = null;
          }
          if (followUp.eq_5d_sl_self_care === "null") {
            followUp.eq_5d_sl_self_care = null;
          }
          if (followUp.eq_5d_sl_usual_tasks === "null") {
            followUp.eq_5d_sl_usual_tasks = null;
          }
          if (followUp.eq_5d_sl_pain_discomfort === "null") {
            followUp.eq_5d_sl_pain_discomfort = null;
          }
          if (followUp.eq_5d_sl_anxiety_depression === "null") {
            followUp.eq_5d_sl_anxiety_depression = null;
          }
          if (followUp.modified_ranking_scale === "null") {
            followUp.modified_ranking_scale = null;
          }
          if (followUp.eq_5d_sl_vas_unknown === true) {
            followUp.eq_5d_sl_vas = 999;
          }
          delete followUp.eq_5d_sl_vas_unknown;

          if (values.scheduled_date) {
            followUp.scheduled_date = cloneDeep(values.scheduled_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss");
          }
          followUp.has_pre_stroke_status =
            values.has_pre_stroke_status === "true"
              ? true
              : values.has_pre_stroke_status === "false"
              ? false
              : null;

          await updateFollowUpRequest(this.props.subjectID, followUp);
          this.props.onSubmit(this.props.subjectID);

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: "Success" },
          });

          notification.success({
            message: "Success",
            description: "Follow up has been successfully updated",
          });
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  collapseSection = (sectionName) => () => {
    this.setState((state) => ({ [sectionName]: !state[sectionName] }));
  };

  onSwitchLock = async () => {
    try {
      if (this.state.locked) {
        await unlockFollowUpRequest(this.props.subjectID);
        this.setState({ locked: false });
      } else {
        await lockFollowUpRequest(this.props.subjectID);
        this.setState({ locked: true });
      }
      message.success("Saved");
    } catch (e) {
      message.error(get(e, "response.data.error", "Error"));
    }
  };

  render() {
    const {
      isLoading,
      requestResult,
      showFollowupForm,
      showContactInformation,
      showAdditionalContactInformation,
      locked,
    } = this.state;
    const {
      getFieldDecorator,
      getFieldValue,
      setFieldsValue,
    } = this.props.form;
    const {
      followUp90dUpdatePermission,
      followUp90dLockPermission,
      followUp90dUnlockPermission,
    } = this.props;

    const isEditable = followUp90dUpdatePermission && !locked;
    const isObtainedBy = getFieldValue("is_obtained_by");
    const providedBy = getFieldValue("provided_by");
    const followUpStatus = getFieldValue("follow_up_status");

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4
            className={classnames("headline-default", classes.toggleHeadline)}
            onClick={this.collapseSection("showContactInformation")}
          >
            <Tooltip title={showContactInformation ? "collapse" : "show"}>
              <Icon
                type="arrow-up"
                className={classes.collapseIcon}
                style={{
                  fontSize: "20px",
                  transform: `rotate(${
                    showContactInformation ? "0" : "180deg"
                  })`,
                }}
              />{" "}
              &nbsp;
            </Tooltip>

            <span className={classes.headlineText}>Contact Information</span>
          </h4>

          {showContactInformation && (
            <div>
              <p>
                <b>Name:</b> {get(this.props, "subject.profile.first_name")}{" "}
                {get(this.props, "subject.profile.last_name")}
              </p>
              <p>
                <b>Phone number:</b> (
                {get(this.props, "subject.profile.phone_number_type_1")}){" "}
                {get(this.props, "subject.profile.phone_number_1")}
              </p>
              {get(this.props, "subject.profile.phone_number_2") && (
                <p>
                  <b>Phone number 2:</b> (
                  {get(this.props, "subject.profile.phone_number_type_2")}){" "}
                  {get(this.props, "subject.profile.phone_number_2")}
                </p>
              )}
              <p>
                <b>Email:</b> {get(this.props, "subject.profile.email")}
              </p>
              <p>
                <b>Consent given:</b>{" "}
                {get(
                  this.props,
                  "subject.has_consent_given",
                  get(this.props, "subject.profile.is_consent_given" || "")
                )
                  ? "Yes"
                  : "No"}
              </p>
              <p>
                <b>Consent documents:</b>
              </p>
              <ul style={{ listStyle: "none" }}>
                {get(this.props, "consent.link") &&
                  (Array.isArray(get(this.props, "consent.link")) ? (
                    get(this.props, "consent.link").map(({ link, name }) => (
                      <li key={name}>
                        <b>
                          <FileLink url={link} text={name} />
                        </b>
                      </li>
                    ))
                  ) : get(this.props, "consent.type") ? (
                    <li>
                      <FileLink
                        url={get(this.props, "consent.link")}
                        text={get(this.props, "consent.type")}
                      />
                    </li>
                  ) : (
                    <li>
                      None. Please provide{" "}
                      <Link to="/consent">consent here</Link>
                    </li>
                  ))}
              </ul>
              <p>
                <b>Comments:</b> {get(this.props, "subject.profile.comments")}
              </p>
            </div>
          )}

          <h4
            className={classnames("headline-default", classes.toggleHeadline)}
            onClick={this.collapseSection("showAdditionalContactInformation")}
          >
            <Tooltip
              title={showAdditionalContactInformation ? "collapse" : "show"}
            >
              <Icon
                type="arrow-up"
                className={classes.collapseIcon}
                style={{
                  fontSize: "20px",
                  transform: `rotate(${
                    showAdditionalContactInformation ? "0" : "180deg"
                  })`,
                }}
              />{" "}
              &nbsp;
            </Tooltip>

            <span className={classes.headlineText}>
              Additional Contact Information
            </span>
          </h4>

          {showAdditionalContactInformation && (
            <div>
              <h5 className="headline-default">Other contacts</h5>

              <Row gutter={12}>
                <Col md={8}>
                  <p>
                    <b>Contact 1</b>
                  </p>
                  <p>
                    <b>Name:</b>{" "}
                    {get(this.props, "subject.profile.contact_1_first_name")}{" "}
                    {get(this.props, "subject.profile.contact_1_last_name")}
                  </p>
                  <p>
                    <b>Relationship:</b>{" "}
                    {get(
                      this.props,
                      "subject.profile.contact_1_relationship_type"
                    )}
                  </p>
                  <p>
                    <b>Phone number:</b> (
                    {get(
                      this.props,
                      "subject.profile.contact_1_phone_number_type"
                    )}
                    ){" "}
                    {get(this.props, "subject.profile.contact_1_phone_number")}
                  </p>
                </Col>

                {get(this.props, "subject.profile.contact_2_first_name") && (
                  <Col md={8}>
                    <p>
                      <b>Contact 2</b>
                    </p>
                    <p>
                      <b>Name:</b>{" "}
                      {get(this.props, "subject.profile.contact_2_first_name")}{" "}
                      {get(this.props, "subject.profile.contact_2_last_name")}
                    </p>
                    <p>
                      <b>Relationship:</b>{" "}
                      {get(
                        this.props,
                        "subject.profile.contact_2_relationship_type"
                      )}
                    </p>
                    <p>
                      <b>Phone number:</b> (
                      {get(
                        this.props,
                        "subject.profile.contact_2_phone_number_type"
                      )}
                      ){" "}
                      {get(
                        this.props,
                        "subject.profile.contact_2_phone_number"
                      )}
                    </p>
                  </Col>
                )}

                <Col md={8}>
                  <p>
                    <b>Family Doctor</b>
                  </p>
                  <p>
                    <b>Name:</b>{" "}
                    {get(
                      this.props,
                      "subject.profile.family_doctor_first_name"
                    )}{" "}
                    {get(this.props, "subject.profile.family_doctor_last_name")}
                  </p>
                  <p>
                    <b>Clinic name:</b>{" "}
                    {get(
                      this.props,
                      "subject.profile.family_doctor_clinic_name"
                    )}
                  </p>
                  <p>
                    <b>Phone number:</b> (
                    {get(
                      this.props,
                      "subject.profile.family_doctor_phone_number_type"
                    )}
                    ){" "}
                    {get(
                      this.props,
                      "subject.profile.family_doctor_phone_number"
                    )}
                  </p>
                </Col>
              </Row>
            </div>
          )}

          <h4
            className={classnames("headline-default", classes.toggleHeadline)}
            onClick={this.collapseSection("showFollowupForm")}
          >
            <Tooltip title={showFollowupForm ? "collapse" : "show"}>
              <Icon
                type="arrow-up"
                className={classes.collapseIcon}
                style={{
                  fontSize: "20px",
                  transform: `rotate(${showFollowupForm ? "0" : "180deg"})`,
                }}
              />{" "}
              &nbsp;
            </Tooltip>
            <span className={classes.headlineText}>{this.props.subjectID}</span>{" "}
            <Badge count="Edit" style={{ backgroundColor: "#2968AE" }} />
          </h4>

          {showFollowupForm && (
            <div>
              {this.props.follow_up_status === "completed" && (
                <p>
                  <Tag color="#49c850">Completed: {moment(this.props.updated).format('YYYY/MM/DD, HH:mm')}</Tag>
                  <Tag color="#49c850">by {get(this.props.updated_by, 'username')}</Tag>
                </p>
              )}
              <p>Scheduled visit(s)</p>

              <Row gutter={12}>
                <Col lg={6}>
                  <Form.Item label="Date">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {getFieldDecorator("scheduled_date", {
                        rules: [
                          {
                            required: ["completed"].includes(followUpStatus),
                            message: "Required",
                          },
                        ],
                        initialValue: get(this.props, "scheduled_date")
                          ? moment
                              .utc(this.props.scheduled_date)
                              .tz(
                                this.props.userTimezone ||
                                  get(this.props, "site.time_zone") ||
                                  "UTC"
                              )
                          : null,
                      })(
                        <DatePicker
                          disabled={!isEditable}
                          placeholder="yyyy-mm-dd"
                          format="YYYY/MM/DD HH:mm"
                          showTime={{ format: "HH:mm" }}
                        />
                      )}
                      &nbsp;
                      {this.props.userShortTimezone ||
                        get(this.props, "site.short_tz") ||
                        "UTC"}
                    </div>
                  </Form.Item>
                </Col>
                <Col lg={6}>
                  <p style={{ marginTop: "30px" }}>
                    <b>Site: </b> {get(this.props, "site.name")}
                  </p>
                </Col>
              </Row>

              <h5 className="headline-default">
                1. Method information is obtained:
              </h5>
              <Row gutter={12}>
                <Col lg={6}>
                  <Form.Item label="Method">
                    {getFieldDecorator("is_obtained_by", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue: get(this.props, "is_obtained_by", ""),
                    })(
                      <Select disabled={!isEditable} placeholder="Select">
                        <Option value="by_phone">By phone</Option>
                        <Option value="in_person">In-person</Option>
                        <Option value="email">Email</Option>
                        <Option value="by_mail">By mail</Option>
                        <Option value="other">Other</Option>
                        <Option value={null}>Select</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                {isObtainedBy === "other" && (
                  <Col lg={6}>
                    <Form.Item label="Other">
                      {getFieldDecorator("obtained_by_other", {
                        rules: [{ required: true, message: "Required" }],
                        initialValue: get(this.props, "obtained_by_other"),
                      })(<Input disabled={!isEditable} />)}
                    </Form.Item>
                  </Col>
                )}
              </Row>

              <h5 className="headline-default">
                2. Who is providing the following information?
              </h5>
              <Row gutter={12}>
                <Col lg={6}>
                  <Form.Item label="Provided by">
                    {getFieldDecorator("provided_by", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue: get(this.props, "provided_by", ""),
                    })(
                      <Select disabled={!isEditable} placeholder="Select">
                        <Option value="patient_self">Patient/ Self</Option>
                        <Option value="surrogate">Surrogate</Option>
                        <Option value="family_member">Family Member</Option>
                        <Option value="care_home_nurse">Care Home Nurse</Option>
                        <Option value="other">Other</Option>
                        <Option value={null}>Select</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                {providedBy === "other" && (
                  <Col lg={6}>
                    <Form.Item label="Other">
                      {getFieldDecorator("provided_by_other", {
                        rules: [{ required: true, message: "Required" }],
                        initialValue: get(this.props, "provided_by_other"),
                      })(<Input disabled={!isEditable} />)}
                    </Form.Item>
                  </Col>
                )}
              </Row>

              <h5 className="headline-default">
                3. EQ-5D-5L Health Questionnaire
              </h5>
              <Row gutter={12}>
                <Col lg={8}>
                  <h6 className="headline-default">DESCRIPTIVE SYSTEM</h6>
                  <Form.Item label="Mobility">
                    {getFieldDecorator("eq_5d_sl_mobility", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue: Number.isInteger(
                        this.props.eq_5d_sl_mobility
                      )
                        ? this.props.eq_5d_sl_mobility.toString()
                        : null,
                    })(
                      <Select disabled={!isEditable} placeholder="Select">
                        <Option value="99">Unknown</Option>
                        <Option value="1">
                          1 - You have no problems in walking about
                        </Option>
                        <Option value="2">
                          2 - You have slight problems in walking about
                        </Option>
                        <Option value="3">
                          3 - You have moderate problems in walking about
                        </Option>
                        <Option value="4">
                          4 - You have severe problems in walking about
                        </Option>
                        <Option value="5">
                          5 - You are unable to walk about
                        </Option>
                        <Option value={null}>Not selected</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item label="Self care">
                    {getFieldDecorator("eq_5d_sl_self_care", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue: Number.isInteger(
                        this.props.eq_5d_sl_self_care
                      )
                        ? this.props.eq_5d_sl_self_care.toString()
                        : null,
                    })(
                      <Select disabled={!isEditable} placeholder="Select">
                        <Option value="99">Unknown</Option>
                        <Option value="1">
                          1 - You have no problems washing or dressing yourself
                        </Option>
                        <Option value="2">
                          2 - You have slight problems washing or dressing
                          yourself
                        </Option>
                        <Option value="3">
                          3 - You have moderate problems washing or dressing
                          yourself
                        </Option>
                        <Option value="4">
                          4 - You have severe problems washing or dressing
                          yourself
                        </Option>
                        <Option value="5">
                          5 - You are unable to wash or dress yourself
                        </Option>
                        <Option value={null}>Not selected</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item label="Usual tasks">
                    {getFieldDecorator("eq_5d_sl_usual_tasks", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue: Number.isInteger(
                        this.props.eq_5d_sl_usual_tasks
                      )
                        ? this.props.eq_5d_sl_usual_tasks.toString()
                        : null,
                    })(
                      <Select disabled={!isEditable} placeholder="Select">
                        <Option value="99">Unknown</Option>
                        <Option value="1">
                          1 - You have no problems doing your usual activities
                        </Option>
                        <Option value="2">
                          2 - You have slight problems doing your usual
                          activities
                        </Option>
                        <Option value="3">
                          3 - You have moderate problems doing your usual
                          activities
                        </Option>
                        <Option value="4">
                          4 - You have severe problems doing your usual
                          activities
                        </Option>
                        <Option value="5">
                          5 - You are unable to do your usual activities
                        </Option>
                        <Option value={null}>Not selected</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item label="Pain / discomfort">
                    {getFieldDecorator("eq_5d_sl_pain_discomfort", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue: Number.isInteger(
                        this.props.eq_5d_sl_pain_discomfort
                      )
                        ? this.props.eq_5d_sl_pain_discomfort.toString()
                        : null,
                    })(
                      <Select disabled={!isEditable} placeholder="Select">
                        <Option value="99">Unknown</Option>
                        <Option value="1">
                          1 - You have no pain or discomfort
                        </Option>
                        <Option value="2">
                          2 - You have slight pain or discomfort
                        </Option>
                        <Option value="3">
                          3 - You have moderate pain or discomfort
                        </Option>
                        <Option value="4">
                          4 - You have severe pain or discomfort
                        </Option>
                        <Option value="5">
                          5 - You have extreme pain or discomfort
                        </Option>
                        <Option value={null}>Not selected</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item label="Anxiety / depression">
                    {getFieldDecorator("eq_5d_sl_anxiety_depression", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue: Number.isInteger(
                        this.props.eq_5d_sl_anxiety_depression
                      )
                        ? this.props.eq_5d_sl_anxiety_depression.toString()
                        : null,
                    })(
                      <Select disabled={!isEditable} placeholder="Select">
                        <Option value="99">Unknown</Option>
                        <Option value="1">
                          1 - You are not anxious or depressed
                        </Option>
                        <Option value="2">
                          2 - You are slightly anxious or depressed
                        </Option>
                        <Option value="3">
                          3 - You are moderately anxious or depressed
                        </Option>
                        <Option value="4">
                          4 - You are severely anxious or depressed?
                        </Option>
                        <Option value="5">
                          5 - You are extremely anxious or depressed
                        </Option>
                        <Option value={null}>Not selected</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>

                <Col lg={6}>
                  <div className={classes.sliderWrapper}>
                    <h6 className="headline-default">
                      VISUAL ANALOG SYSTEM (VAS)
                    </h6>

                    <Form.Item label="The best health you can imagine">
                      <div
                        style={{
                          height: "300px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "20px",
                        }}
                      >
                        {getFieldDecorator("eq_5d_sl_vas", {
                          rules: [
                            {
                              required: ["completed"].includes(followUpStatus),
                              message: "Required",
                            },
                          ],
                          initialValue:
                            this.props.eq_5d_sl_vas ||
                            this.props.eq_5d_sl_vas === 0
                              ? +this.props.eq_5d_sl_vas
                              : undefined,
                        })(
                          <Slider
                            disabled={
                              !isEditable ||
                              getFieldValue("eq_5d_sl_vas_unknown") === true
                            }
                            type="number"
                            min={0}
                            max={100}
                            vertical
                            marks={{
                              0: "0",
                              10: "10",
                              20: "20",
                              30: "30",
                              40: "40",
                              50: "50",
                              60: "60",
                              70: "70",
                              80: "80",
                              90: "90",
                              100: "100",
                            }}
                          />
                        )}

                        {!getFieldValue("eq_5d_sl_vas_unknown") && (
                          <div
                            style={{
                              width: "30px",
                              fontSize: "18px",
                              marginLeft: "45px",
                            }}
                          >
                            {getFieldValue("eq_5d_sl_vas")}
                          </div>
                        )}
                      </div>
                    </Form.Item>
                    <p>The worst health you can imagine</p>

                    <Form.Item>
                      <label>
                        {getFieldDecorator("eq_5d_sl_vas_unknown", {
                          initialValue: getFieldValue("eq_5d_sl_vas") === 999,
                          valuePropName: "checked",
                        })(
                          <Checkbox
                            onChange={(e) => {
                              if (e.target.checked) {
                                setFieldsValue({ eq_5d_sl_vas: 999 });
                              } else {
                                setFieldsValue({ eq_5d_sl_vas: 0 });
                              }
                            }}
                          >
                            Unknown
                          </Checkbox>
                        )}
                      </label>
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              <h5 className="headline-default">4. Modified Rankin Scale</h5>
              <Row gutter={12}>
                <Col lg={8}>
                  <Form.Item label="Rankin Scale">
                    {getFieldDecorator("modified_ranking_scale", {
                      rules: [
                        {
                          required: [
                            "in_progress",
                            "lost",
                            "completed",
                            "patient_deceased",
                          ].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue: Number.isInteger(
                        this.props.modified_ranking_scale
                      )
                        ? this.props.modified_ranking_scale.toString()
                        : null,
                    })(
                      <Select disabled={!isEditable}>
                        <Option value={null}>Select</Option>
                        <Option value="99">Unknown</Option>
                        <Option value="0">0</Option>
                        <Option value="1">1</Option>
                        <Option value="2">2</Option>
                        <Option value="3">3</Option>
                        <Option value="4">4</Option>
                        <Option value="5">5</Option>
                        <Option value="6">6 - Death</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <h5 className="headline-default">
                5. Is the person back to pre-stroke status?
              </h5>
              <Row gutter={12}>
                <Col lg={12}>
                  <Form.Item>
                    {getFieldDecorator("has_pre_stroke_status", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue:
                        this.props.has_pre_stroke_status !== null
                          ? get(
                              this.props,
                              "has_pre_stroke_status",
                              ""
                            ).toString()
                          : null,
                    })(
                      <Radio.Group disabled={!isEditable}>
                        <Radio value="true">Yes</Radio>
                        <Radio value="false">No</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <h5 className="headline-default">
                6. What is the status of the follow-up?
              </h5>
              <Row gutter={12}>
                <Col lg={12}>
                  <Form.Item>
                    {getFieldDecorator("follow_up_status", {
                      rules: [
                        {
                          required: ["completed"].includes(followUpStatus),
                          message: "Required",
                        },
                      ],
                      initialValue:
                        this.props.follow_up_status !== null
                          ? get(this.props, "follow_up_status", "").toString()
                          : null,
                    })(
                      <Radio.Group
                        disabled={!isEditable}
                        onChange={(e) => {
                          if (e.target.value === "patient_deceased") {
                            this.props.form.setFieldsValue({
                              modified_ranking_scale: "6",
                            });
                          }
                        }}
                      >
                        <Radio value="not_started">Not started</Radio>
                        <Radio value="in_progress">In progress</Radio>
                        <Radio value="completed">Completed</Radio>
                        <Radio value="lost">Lost in follow-up</Radio>
                        <Radio value="consent_not_given">
                          Not required - consent not given
                        </Radio>
                        <Radio value="patient_deceased">
                          Not required - patient deceased
                        </Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={12}>
                <Col lg={12}>
                  <Form.Item label="Comments/ Notes:">
                    {getFieldDecorator("event_comments", {
                      rules: [
                        {
                          required: ["in_progress", "lost"].includes(
                            followUpStatus
                          ),
                          message: "Required",
                        },
                      ],
                      initialValue: get(this.props, "event_comments"),
                    })(<Input.TextArea disabled={!isEditable} rows={4} />)}
                  </Form.Item>
                </Col>
              </Row>

              {requestResult.type && (
                <Alert
                  message={requestResult.message}
                  type={requestResult.type}
                  className={classes.submitResult}
                />
              )}

              <Form.Item className={classes.formActions}>
                {isEditable && (
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    className={classes.submitButton}
                  >
                    Save
                    {isLoading && <Icon type="loading" />}
                  </Button>
                )}
                &nbsp;&nbsp;
                <Tooltip placement="topLeft" title="Lock / Unlock the FollowUp">
                  Lock status: &nbsp;
                  <Switch
                    disabled={
                      (!followUp90dUnlockPermission && locked) ||
                      (!followUp90dLockPermission && !locked)
                    }
                    checked={!locked}
                    onChange={this.onSwitchLock}
                  />
                </Tooltip>
              </Form.Item>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  followUp90dCreatePermission: getFollowUp90dCreatePermissionBySite(
    get(props, "site.id")
  )(state),
  followUp90dUpdatePermission: getFollowUp90dUpdatePermissionBySite(
    get(props, "site.id")
  )(state),
  followUp90dLockPermission: getFollowUp90dLockPermissionBySite(
    get(props, "site.id")
  )(state),
  followUp90dUnlockPermission: getFollowUp90dUnlockPermissionBySite(
    get(props, "site.id")
  )(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "followUp90Day" })(
  connect(mapStateToProps, mapDispatchToProps)(FollowUp90DayForm)
);



// WEBPACK FOOTER //
// ./src/components/FollowUp90DayForm/FollowUp90DayForm.js